export const environment = {
  production: false,
  apiUrl: 'https://api.forward-shrd.dev.zsservices.com',
  idmLoginUrl: 'https://idm.dev.zsservices.com/OFS/IdentityManager/app/Web/login.aspx',
  idmMyAccount: 'https://idm.dev.zsservices.com/OFS/IdentityManager/app/Web/MyAccount.aspx',
  idmLogoffUrl: 'https://idm.dev.zsservices.com/OFS/IdentityManager/app/Web/Logout.aspx?returnUrl=https%3a%2f%2fidm.dev.zsservices.com%2fOFS%2fIdentityManager%2fapp%2fWeb%2fMyAccount.aspx',
  landingPageLinks: {
    governance: 'welcome',
    driverless: 'https://apps.powerapps.com/play/e/6c2ded82-f0f2-e7c4-8979-d82114f4251a/a/6c74d2ef-5b5e-4911-8019-d69804f768c4?tenantId=5fc8dec7-9ec4-43e0-8ea6-edfeec8aa94b&hint=9033b007-59d4-46c9-8117-ad6308e38f18&sourcetime=1762506485440&source=portal&hideNavbar=true',
    dashboard: 'pages/reports/records',
    forwardAi: 'https://shrd.fab.zsservices.com/'
  }
};
